import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import ForgetPassword from "./auth/forgetpwd/reducer"
import Login from "./auth/login/reducer"
import Profile from "./auth/profile/reducer"
import Account from "./auth/register/reducer"

//Calendar
import calendar from "./calendar/reducer"

//Catalogs
import coordinations from "./catalogs/Coordinations/reducer"
import customersReducer from "./catalogs/Customers/reducer"
import emaRegulations from "./catalogs/EmaRegulations/reducer"
import internalSamples from "./catalogs/InternalSamples/reducer"
import kinds from "./catalogs/Kinds/reducer"
import labAreas from "./catalogs/LabAreas/reducer"
import labsReducer from "./catalogs/Laboratories/reducer"
import labSegments from "./catalogs/LabSegments/reducer"
import labTest from "./catalogs/LabTests/reducer"
import labTestSamples from "./catalogs/LabTestSamples/reducer"
import labType from "./catalogs/LabTypes/reducer"
import locations from "./catalogs/Locations/reducer"
import catalogsMenu from "./catalogs/menu/reducer"
import norms from "./catalogs/Norms/reducer"
import products from "./catalogs/Products/reducer"
import productTypesReducer from "./catalogs/ProductTypes/reducer"
import providers from "./catalogs/Providers/reducer"
import quotationsReducer from "./catalogs/Quotations/reducer"
import regions from "./catalogs/Regions/reducer"
import statusReducer from "./catalogs/StatusSamples/reducer"
import surveyCategoriesReducer from "./catalogs/SurveyCategories/reducer"
import surveyConceptsReducer from "./catalogs/SurveyConcepts/reducer"
import technicalAdvisers from "./catalogs/TechnicalAdvisers/reducer"
import typesRegulations from "./catalogs/TypesRegulations/reducer"
import unitMeasures from "./catalogs/UnitMeasures/reducer"
import usersReducer from "./catalogs/Users/reducer"
import serviceTypes from "./catalogs/ServiceTypes/reducer"
import defaultAssignments from "./catalogs/DefaultAssignments/reducer"

// Lab Requests Reducers
import labRequestReducer from "./labCitec/labRequest/reducer"
import labRequestAssignmentReducer from "./labCitec/labRequestAssignments/reducer"
import labRequestCalendarReducer from "./labCitec/labRequestCalendaredRecord/reducer"
import labRequestDeliveryResultReducer from "./labCitec/labRequestDeliveryResult/reducer"
import labRequestDeliveryResultPartialReducer from "./labCitec/labRequestDeliveryResultPartial/reducer"
import labRequestEssayReducer from "./labCitec/labRequestEssay/reducer"
import labRequestIncidentsReducer from "./labCitec/labRequestIncidents/reducer"
import labRequestSurveyQuotesReducer from "./labCitec/labRequestQuotations/reducer"
import labRequestReportReducer from "./labCitec/labRequestReport/reducer"
import labRequestReportAuxReducer from "./labCitec/labRequestReportAux/reducer"
import labRequestReportRoiReducer from "./labCitec/labRequestReportsRoi/reducer"
import labRequestReqReducer from "./labCitec/labRequestReq/reducer"
import labRequestSampleReducer from "./labCitec/labRequestSamples/reducer"
import labRequestSurveyReducer from "./labCitec/labRequestSurvey/reducer"
import labRequestSurveyResponseReducer from "./labCitec/labRequestSurveyResp/reducer"
import labRequestTestReducer from "./labCitec/labRequestTest/reducer"
import labRequestTestSampleReducer from "./labCitec/labRequestTestSamples/reducer"
import labRequestTrackingsReducer from "./labCitec/labRequestTrackings/reducer"

// Notifications Reducers
import notificationManagersReducer from "./notifications/managers/reducer"
import notificationResponsiblesReducer from "./notifications/responsibles/reducer"

// Norm Library Reducers
import normLibraryReducer from "./normsLibrary/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  calendar,
  catalogsMenu,
  labType,
  labAreas,
  labSegments,
  coordinations,
  unitMeasures,
  serviceTypes,
  defaultAssignments,
  locations,
  kinds,
  customersReducer,
  productTypesReducer,
  providers,
  typesRegulations,
  technicalAdvisers,
  products,
  regions,
  norms,
  emaRegulations,
  internalSamples,
  labTest,
  labTestSamples,
  surveyConceptsReducer,
  surveyCategoriesReducer,
  usersReducer,
  statusReducer,
  labRequestReducer,
  labRequestReportReducer,
  labRequestReportAuxReducer,
  labRequestReqReducer,
  labRequestTestReducer,
  labRequestSampleReducer,
  labRequestAssignmentReducer,
  labsReducer,
  labRequestTrackingsReducer,
  labRequestIncidentsReducer,
  notificationManagersReducer,
  notificationResponsiblesReducer,
  normLibraryReducer,
  labRequestDeliveryResultReducer,
  labRequestCalendarReducer,
  labRequestEssayReducer,
  labRequestTestSampleReducer,
  labRequestSurveyReducer,
  labRequestSurveyResponseReducer,
  labRequestDeliveryResultPartialReducer,
  quotationsReducer,
  labRequestSurveyQuotesReducer,
  labRequestReportRoiReducer,
})

export default rootReducer
